import { Box } from "@chakra-ui/react";
import { colors, GOI_COMPANY_ADDRESS } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { ReactNode } from "react";

/** 형광펜 하이라이트(노란 펜 하단 강조). 짧은 구절 강조용. */
export function Highlighter({ children }: { children: ReactNode }) {
  return (
    <Box as="span" style={{ background: "linear-gradient(to top, #FFE27A 48%, transparent 48%)" }}>
      {children}
    </Box>
  );
}

/** 섹션 헤더: 번호(orange) + h2 제목. README 섹션 1·2 공용. */
export function RecipientSectionHeader({ num, title }: { num: string; title: string }) {
  return (
    <BaseStack direction="horizontal" spacing={8} alignItems="baseline">
      <Box
        as="span"
        className="subtitle_18_sb"
        color={colors.orange650}
        style={{ fontSize: "24px" }}
      >
        {num}
      </Box>
      <Box
        as="h2"
        className="subtitle_18_sb"
        color={colors.gray900}
        whiteSpace="pre-line"
        style={{ fontSize: "19px" }}
      >
        {title}
      </Box>
    </BaseStack>
  );
}

/** 짧은 footer — 공용 RenewalFooter가 길어 랜딩용 컴팩트 버전(사업자 정보 + 고객센터). */
export function RecipientFooter() {
  return (
    <BaseStack width="100%" bg={colors.gray50} p="24px 20px" spacing={4}>
      <Box className="caption_12_r" color={colors.gray600}>
        (주)고이장례연구소 · 대표이사 송슬옹
      </Box>
      <Box className="caption_12_r" color={colors.gray500}>
        사업자 등록번호 831-87-01971 · 통신판매업신고 2021-서울관악-2417
      </Box>
      <Box className="caption_12_r" color={colors.gray500}>
        {GOI_COMPANY_ADDRESS}
      </Box>
      <Box className="caption_12_r" color={colors.gray500}>
        고객센터 1666-9784 · contact@goifuneral.co.kr
      </Box>
    </BaseStack>
  );
}

/** 다운 애로우 — 순수 CSS 도형(자루 그라데이션 + 삼각형 촉). README 1-D. */
export function RecipientDownArrow() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" py="4px">
      <Box
        width="20px"
        height="22px"
        style={{
          background: `linear-gradient(to bottom, ${colors.orange500}, ${colors.orange650})`,
        }}
      />
      <Box
        width="0"
        height="0"
        style={{
          borderLeft: "22px solid transparent",
          borderRight: "22px solid transparent",
          borderTop: `24px solid ${colors.orange700}`,
        }}
      />
    </Box>
  );
}
